<div class="manifeste-page">

  <div class="page-header">
    <div class="page-header__info">
      <h1 class="page-header__title">
        <i class="fal fa-file-alt"></i>
        Manifestes
      </h1>
      <p class="page-header__sub">Suivi des feuilles de route interurbaines</p>
    </div>
    <div class="header-actions">
      <button class="btn-create" (click)="nouveau()" *ngIf="peutCreerManifeste()">
        <i class="fal fa-plus"></i>
        Nouveau manifeste
      </button>
      <button class="btn-refresh" (click)="charger()" [disabled]="indicateurChargement">
        <i class="fal fa-sync" [class.fa-spin]="indicateurChargement"></i>
        Actualiser
      </button>
    </div>
  </div>

  <!-- KPIs rapides -->
  <div class="kpi-row" *ngIf="!indicateurChargement && manifestes.length > 0">
    <div class="kpi-mini" *ngFor="let s of STATUTS.slice(1)">
      <span class="statut-badge" [ngClass]="badgeStatut(s.valeur)">{{ s.libelle }}</span>
      <strong>{{ compterParStatut(s.valeur) }}</strong>
    </div>
  </div>

  <!-- Filtres -->
  <div class="filtres-bar">
    <div class="filtre-search">
      <i class="fal fa-search"></i>
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerFiltres()"
             placeholder="Référence, zone…" />
    </div>
    <select [(ngModel)]="statutFiltre" (ngModelChange)="appliquerFiltres()" class="filtre-select">
      <option *ngFor="let s of STATUTS" [value]="s.valeur">{{ s.libelle }}</option>
    </select>
    <button class="btn-reset" *ngIf="recherche || statutFiltre"
            (click)="recherche=''; statutFiltre=''; appliquerFiltres()">
      <i class="fal fa-times"></i> Réinitialiser
    </button>
  </div>

  <!-- Chargement -->
  <div class="etat-chargement" *ngIf="indicateurChargement">
    <div class="spinner"></div>
    <span>Chargement des manifestes…</span>
  </div>

  <!-- Vide -->
  <div class="etat-vide" *ngIf="!indicateurChargement && manifestesFiltres.length === 0">
    <i class="fal fa-file-alt"></i>
    <p>Aucun manifeste trouvé.</p>
  </div>

  <!-- Tableau -->
  <div class="table-wrapper" *ngIf="!indicateurChargement && manifestesFiltres.length > 0">
    <table class="data-table">
      <thead>
        <tr>
          <th>Référence</th>
          <th>Trajet</th>
          <th>Colis</th>
          <th>Chauffeur / Véhicule</th>
          <th>Date expédition</th>
          <th>Date arrivée</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let m of manifestesFiltres">
          <td class="col-ref">
            <strong>{{ m.numeroReference ?? '—' }}</strong>
            <small>ID #{{ m.id }}</small>
          </td>
          <td class="col-trajet">
            <div class="zone-trajet">
              <span class="zone-badge zone-badge--depart">
                <i class="fal fa-map-marker-alt"></i>
                {{ m.zoneDepartNom ?? '—' }}
              </span>
              <i class="fal fa-long-arrow-right arrow-trajet"></i>
              <span class="zone-badge zone-badge--arrivee">
                <i class="fal fa-map-marker-alt"></i>
                {{ m.zoneArriveeNom ?? '—' }}
              </span>
            </div>
          </td>
          <td class="col-colis">
            <button class="btn-commandes-link"
                    (click)="voirCommandes(m)"
                    title="Voir les commandes">
              <i class="fal fa-boxes"></i>
              <span class="nb-colis">{{ m.nombreTotalColis ?? (m.commandes?.length ?? 0) }}</span>
              colis
            </button>
          </td>
          <td>
            <span *ngIf="m.chauffeur">{{ m.chauffeur.prenom }} {{ m.chauffeur.nom }}</span>
            <span class="text-muted" *ngIf="!m.chauffeur">—</span>
            <small class="immat" *ngIf="m.immatriculationVehicule">{{ m.immatriculationVehicule }}</small>
          </td>
          <td>{{ m.dateExpedition | date:'dd/MM/yy HH:mm' }}</td>
          <td>
            <span *ngIf="m.dateArrivee">{{ m.dateArrivee | date:'dd/MM/yy HH:mm' }}</span>
            <span class="text-muted" *ngIf="!m.dateArrivee">—</span>
          </td>
          <td>
            <span class="statut-badge" [ngClass]="badgeStatut(statutManifeste(m))">
              {{ libelleStatut(statutManifeste(m)) }}
            </span>
          </td>
          <td>
            <div class="actions-cell">
              <!-- Voir le détail -->
              <button class="btn-action btn-action--purple"
                      (click)="voirDetail(m)" title="Voir le détail">
                <i class="fal fa-eye"></i>
              </button>

              <!-- Workflow standard (zone départ) -->
              <button class="btn-action btn-action--teal"
                      *ngIf="['EN_PREPARATION','ENREGISTRE'].includes(statutManifeste(m))"
                      (click)="changerStatut(m, 'CHARGE')" title="Marquer chargé sur véhicule">
                <i class="fal fa-truck-loading"></i>
              </button>
              <button class="btn-action btn-action--blue"
                      *ngIf="statutManifeste(m) === 'CHARGE'"
                      (click)="changerStatut(m, 'EXPEDIE')" title="Expédier (départ)">
                <i class="fal fa-paper-plane"></i>
              </button>
              <button class="btn-action btn-action--orange"
                      *ngIf="statutManifeste(m) === 'EXPEDIE'"
                      (click)="changerStatut(m, 'EN_TRANSIT')" title="Marquer en transit">
                <i class="fal fa-route"></i>
              </button>
              <button class="btn-action btn-action--violet"
                      *ngIf="statutManifeste(m) === 'EN_TRANSIT'"
                      (click)="changerStatut(m, 'ARRIVE')" title="Marquer arrivé à destination">
                <i class="fal fa-flag-checkered"></i>
              </button>

              <!-- RÉCONCILIATION (zone arrivée) -->
              <button class="btn-action btn-action--reconciliation"
                      *ngIf="statutManifeste(m) === 'ARRIVE'"
                      (click)="ouvrirReconciliation(m)"
                      title="Effectuer la réconciliation des colis reçus">
                <i class="fal fa-clipboard-check"></i>
              </button>

              <!-- AFFECTATION LIVREURS last-mile (zone arrivée) -->
              <button class="btn-action btn-action--lastmile"
                      *ngIf="statutManifeste(m) === 'RECEPTIONNE'"
                      (click)="ouvrirAffectation(m)"
                      title="Assigner des livreurs pour la livraison finale">
                <i class="fal fa-user-hard-hat"></i>
              </button>

              <!-- SUPPRESSION (admin uniquement) -->
              <button class="btn-action btn-action--danger"
                      *ngIf="peutSupprimerManifeste()"
                      (click)="supprimer(m)"
                      title="Supprimer ce manifeste">
                <i class="fal fa-trash-alt"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="pagination" *ngIf="totalPages > 1">
      <button (click)="changerPage(pageCourante - 1)" [disabled]="pageCourante === 1">
        <i class="fal fa-chevron-left"></i>
      </button>
      <ng-container *ngFor="let p of pages">
        <button (click)="changerPage(p)" [class.active]="p === pageCourante"
                *ngIf="p === 1 || p === totalPages || Math.abs(p - pageCourante) <= 2">
          {{ p }}
        </button>
      </ng-container>
      <button (click)="changerPage(pageCourante + 1)" [disabled]="pageCourante === totalPages">
        <i class="fal fa-chevron-right"></i>
      </button>
    </div>
  </div>

</div>

<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<!-- MODAL CRÉATION                                                             -->
<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="afficherModalCreation" (click)="fermerModalCreation()">
  <div class="modal-card modal-card--large" (click)="$event.stopPropagation()">

    <!-- En-tête -->
    <div class="modal-header">
      <div class="modal-header__left">
        <div class="modal-header__icon">
          <i class="fal fa-file-alt"></i>
        </div>
        <div>
          <h3>Nouveau manifeste</h3>
          <p class="modal-header__sub">
            {{ etapeCreation === 1 ? 'Renseignez les informations du trajet' : 'Sélectionnez les commandes à inclure' }}
          </p>
        </div>
      </div>
      <button class="modal-close" (click)="fermerModalCreation()" [disabled]="creationEnCours">
        <i class="fal fa-times"></i>
      </button>
    </div>

    <!-- Indicateur d'étapes -->
    <div class="steps-bar">
      <div class="step" [class.step--active]="etapeCreation === 1" [class.step--done]="etapeCreation > 1">
        <div class="step__circle">
          <i class="fal fa-check" *ngIf="etapeCreation > 1"></i>
          <span *ngIf="etapeCreation <= 1">1</span>
        </div>
        <span class="step__label">Informations</span>
      </div>
      <div class="step__connector" [class.step__connector--done]="etapeCreation > 1"></div>
      <div class="step" [class.step--active]="etapeCreation === 2">
        <div class="step__circle">
          <span>2</span>
        </div>
        <span class="step__label">Commandes</span>
      </div>
    </div>

    <!-- ── ÉTAPE 1 ── -->
    <ng-container *ngIf="etapeCreation === 1">
      <div class="modal-body">
        <div class="modal-grid">

          <div class="modal-field modal-field--full">
            <label>Référence du manifeste <span class="field-opt">(optionnel)</span></label>
            <div class="input-with-icon">
              <i class="fal fa-hashtag"></i>
              <input type="text" [(ngModel)]="formulaireCreation.numeroReference"
                     placeholder="Ex: MAN-ABJ-BKE-001" />
            </div>
          </div>

          <div class="modal-field">
            <label>Zone de départ <span class="required">*</span></label>
            <div class="input-with-icon">
              <i class="fal fa-map-marker-alt" style="color: #4299e1"></i>
              <select [(ngModel)]="formulaireCreation.zoneDepartId">
                <option [ngValue]="null">— Sélectionner —</option>
                <option *ngFor="let z of zones" [ngValue]="z.id">{{ z.nom }}</option>
              </select>
            </div>
          </div>

          <div class="modal-field">
            <label>Zone d'arrivée <span class="required">*</span></label>
            <div class="input-with-icon">
              <i class="fal fa-map-marker-alt" style="color: #9f7aea"></i>
              <select [(ngModel)]="formulaireCreation.zoneArriveeId">
                <option [ngValue]="null">— Sélectionner —</option>
                <option *ngFor="let z of zones" [ngValue]="z.id"
                        [disabled]="z.id === +formulaireCreation.zoneDepartId">
                  {{ z.nom }}
                </option>
              </select>
            </div>
          </div>

          <div class="modal-field">
            <label>Immatriculation véhicule</label>
            <div class="input-with-icon">
              <i class="fal fa-truck"></i>
              <input type="text" [(ngModel)]="formulaireCreation.immatriculationVehicule"
                     placeholder="Ex: AB-1234-CI" />
            </div>
          </div>

          <div class="modal-field">
            <label>Poids total (kg)</label>
            <div class="input-with-icon">
              <i class="fal fa-weight"></i>
              <input type="number" min="0" step="0.1" [(ngModel)]="formulaireCreation.poidsTotal"
                     placeholder="0.0" />
            </div>
          </div>

          <div class="modal-field modal-field--full">
            <label>Description du contenu</label>
            <textarea rows="2" [(ngModel)]="formulaireCreation.descriptionContenu"
                      placeholder="Description des marchandises transportées…"></textarea>
          </div>

          <div class="modal-field modal-field--full">
            <label>Observations</label>
            <textarea rows="2" [(ngModel)]="formulaireCreation.observations"
                      placeholder="Remarques particulières…"></textarea>
          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-modal-cancel" (click)="fermerModalCreation()">
          <i class="fal fa-times"></i> Annuler
        </button>
        <button class="btn-modal-primary" (click)="passerEtape2()">
          Commandes <i class="fal fa-arrow-right"></i>
        </button>
      </div>
    </ng-container>

    <!-- ── ÉTAPE 2 : sélection des commandes ── -->
    <ng-container *ngIf="etapeCreation === 2">

      <!-- Bandeau trajet -->
      <div class="trajet-banner">
        <div class="trajet-banner__zone trajet-banner__zone--depart">
          <i class="fal fa-map-marker-alt"></i>
          <span>{{ nomZone(formulaireCreation.zoneDepartId) }}</span>
        </div>
        <div class="trajet-banner__arrow">
          <div class="trajet-banner__line"></div>
          <i class="fal fa-truck"></i>
          <div class="trajet-banner__line"></div>
        </div>
        <div class="trajet-banner__zone trajet-banner__zone--arrivee">
          <i class="fal fa-map-marker-alt"></i>
          <span>{{ nomZone(formulaireCreation.zoneArriveeId) }}</span>
        </div>
      </div>

      <div class="modal-body modal-body--commandes">

        <!-- Barre outils commandes -->
        <div class="cmd-toolbar">
          <!-- Ligne 1 : recherche + boutons -->
          <div class="cmd-toolbar__row">
            <div class="filtre-search filtre-search--sm">
              <i class="fal fa-search"></i>
              <input type="text" [(ngModel)]="rechercheCommande"
                     (ngModelChange)="filtrerCommandesEligibles()"
                     placeholder="N° commande, expéditeur, destinataire…" />
            </div>

            <!-- Bouton filtres -->
            <button class="cmd-filtres-toggle" [class.cmd-filtres-toggle--active]="filtresOuverts || nbFiltresActifs > 0"
                    (click)="filtresOuverts = !filtresOuverts">
              <i class="fal fa-sliders-h"></i>
              Filtres
              <span class="cmd-filtres-badge" *ngIf="nbFiltresActifs > 0">{{ nbFiltresActifs }}</span>
            </button>

            <!-- Tri -->
            <select class="cmd-select cmd-select--tri" [(ngModel)]="filtreTri" (ngModelChange)="filtrerCommandesEligibles()">
              <option value="date_desc">Plus récentes</option>
              <option value="date_asc">Plus anciennes</option>
              <option value="montant_desc">Montant ↓</option>
              <option value="montant_asc">Montant ↑</option>
              <option value="expediteur">Expéditeur A→Z</option>
            </select>

            <div class="cmd-toolbar__actions">
              <span class="cmd-count">
                <strong>{{ commandesSelectionnees.size }}</strong> / {{ commandesEligiblesFiltrees.length }} sélectionnée(s)
              </span>
              <button class="btn-text" (click)="toutSelectionner()"
                      *ngIf="commandesEligiblesFiltrees.length > 0 && commandesSelectionnees.size < commandesEligiblesFiltrees.length">
                <i class="fal fa-check-square"></i> Tout
              </button>
              <button class="btn-text btn-text--danger" (click)="toutDeselectionner()"
                      *ngIf="commandesSelectionnees.size > 0">
                <i class="fal fa-square"></i> Aucun
              </button>
            </div>
          </div>

          <!-- Ligne 2 : panneau filtres dépliable -->
          <div class="cmd-filtres-panel" *ngIf="filtresOuverts">
            <div class="cmd-filtres-grid">

              <!-- Client / expéditeur -->
              <div class="cmd-filtre-group">
                <label class="cmd-filtre-label"><i class="fal fa-user"></i> Client</label>
                <select class="cmd-select" [(ngModel)]="filtreClientId" (ngModelChange)="filtrerCommandesEligibles()">
                  <option value="">Tous les clients</option>
                  <option *ngFor="let c of clients" [value]="c.id">{{ nomClient(c) }}</option>
                </select>
              </div>

              <!-- Statut -->
              <div class="cmd-filtre-group">
                <label class="cmd-filtre-label"><i class="fal fa-tag"></i> Statut</label>
                <select class="cmd-select" [(ngModel)]="filtreStatutCmd" (ngModelChange)="filtrerCommandesEligibles()">
                  <option value="">Tous les statuts</option>
                  <option *ngFor="let s of statutsDisponibles" [value]="s">{{ libelleStatutCommande(s) }}</option>
                </select>
              </div>

              <!-- Date de création — début -->
              <div class="cmd-filtre-group">
                <label class="cmd-filtre-label"><i class="fal fa-calendar-alt"></i> Du</label>
                <input type="date" class="cmd-select" [(ngModel)]="filtreDateDebut" (ngModelChange)="filtrerCommandesEligibles()">
              </div>

              <!-- Date de création — fin -->
              <div class="cmd-filtre-group">
                <label class="cmd-filtre-label"><i class="fal fa-calendar-alt"></i> Au</label>
                <input type="date" class="cmd-select" [(ngModel)]="filtreDateFin" (ngModelChange)="filtrerCommandesEligibles()">
              </div>

              <!-- Montant min -->
              <div class="cmd-filtre-group">
                <label class="cmd-filtre-label"><i class="fal fa-coins"></i> Montant min (FCFA)</label>
                <input type="number" class="cmd-select" placeholder="0" [(ngModel)]="filtreMontantMin" (ngModelChange)="filtrerCommandesEligibles()">
              </div>

              <!-- Montant max -->
              <div class="cmd-filtre-group">
                <label class="cmd-filtre-label"><i class="fal fa-coins"></i> Montant max (FCFA)</label>
                <input type="number" class="cmd-select" placeholder="Sans limite" [(ngModel)]="filtreMontantMax" (ngModelChange)="filtrerCommandesEligibles()">
              </div>

            </div>

            <!-- Réinitialiser -->
            <button class="cmd-reset-btn" *ngIf="nbFiltresActifs > 0" (click)="reinitialiserFiltresCmd()">
              <i class="fal fa-times-circle"></i> Réinitialiser les filtres
            </button>
          </div>

          <!-- Tags filtres actifs -->
          <div class="cmd-filtres-tags" *ngIf="nbFiltresActifs > 0 && !filtresOuverts">
            <span class="cmd-filtre-tag" *ngIf="filtreClientId !== ''">
              <i class="fal fa-user"></i> {{ nomClientSelectionne }}
              <button (click)="filtreClientId = ''; filtrerCommandesEligibles()"><i class="fal fa-times"></i></button>
            </span>
            <span class="cmd-filtre-tag" *ngIf="filtreStatutCmd">
              <i class="fal fa-tag"></i> {{ libelleStatutCommande(filtreStatutCmd) }}
              <button (click)="filtreStatutCmd = ''; filtrerCommandesEligibles()"><i class="fal fa-times"></i></button>
            </span>
            <span class="cmd-filtre-tag" *ngIf="filtreDateDebut">
              <i class="fal fa-calendar-alt"></i> Du {{ filtreDateDebut }}
              <button (click)="filtreDateDebut = ''; filtrerCommandesEligibles()"><i class="fal fa-times"></i></button>
            </span>
            <span class="cmd-filtre-tag" *ngIf="filtreDateFin">
              <i class="fal fa-calendar-alt"></i> Au {{ filtreDateFin }}
              <button (click)="filtreDateFin = ''; filtrerCommandesEligibles()"><i class="fal fa-times"></i></button>
            </span>
            <span class="cmd-filtre-tag" *ngIf="filtreMontantMin != null">
              <i class="fal fa-coins"></i> Min {{ filtreMontantMin | number }} FCFA
              <button (click)="filtreMontantMin = null; filtrerCommandesEligibles()"><i class="fal fa-times"></i></button>
            </span>
            <span class="cmd-filtre-tag" *ngIf="filtreMontantMax != null">
              <i class="fal fa-coins"></i> Max {{ filtreMontantMax | number }} FCFA
              <button (click)="filtreMontantMax = null; filtrerCommandesEligibles()"><i class="fal fa-times"></i></button>
            </span>
          </div>
        </div>

        <!-- Chargement éligibles -->
        <div class="etat-inline" *ngIf="chargementCommandes">
          <div class="spinner spinner--sm"></div>
          <span>Chargement des commandes éligibles…</span>
        </div>

        <!-- Vide + recherche en cours -->
        <div class="etat-inline" *ngIf="!chargementCommandes && commandesEligiblesFiltrees.length === 0 && rechercheEnCours">
          <div class="spinner spinner--sm"></div>
          <span>Recherche de « {{ rechercheCommande }} »…</span>
        </div>

        <!-- Vide sans recherche -->
        <div class="etat-inline etat-inline--empty"
             *ngIf="!chargementCommandes && commandesEligiblesFiltrees.length === 0 && !rechercheEnCours && commandesRechercheesUniques.length === 0">
          <div class="etat-inline__icon">
            <i class="fal fa-inbox"></i>
          </div>
          <div>
            <p class="etat-inline__title">Aucune commande disponible</p>
            <p class="etat-inline__sub" *ngIf="!rechercheCommande">
              Il n'y a pas de commande interurbaine STANDARD en attente de manifeste.<br>
              Vous pouvez quand même créer le manifeste vide et ajouter des commandes plus tard.
            </p>
            <p class="etat-inline__sub" *ngIf="rechercheCommande">
              Aucune commande trouvée pour « {{ rechercheCommande }} ».
            </p>
          </div>
        </div>

        <!-- Liste des commandes -->
        <div class="commandes-liste" *ngIf="!chargementCommandes && commandesEligiblesFiltrees.length > 0">
          <label class="cmd-item"
                 *ngFor="let c of commandesEligiblesFiltrees"
                 [class.cmd-item--selected]="commandesSelectionnees.has(c.id)">
            <div class="cmd-item__checkbox">
              <input type="checkbox"
                     [checked]="commandesSelectionnees.has(c.id)"
                     (change)="toggleCommande(c.id)" />
              <div class="cmd-item__check-visual">
                <i class="fal fa-check" *ngIf="commandesSelectionnees.has(c.id)"></i>
              </div>
            </div>
            <div class="cmd-item__body">
              <div class="cmd-item__top">
                <strong class="cmd-item__ref-num">{{ c.numeroCommande ?? c.numeroSuivi ?? '#' + c.id }}</strong>
                <span class="cmd-item__statut-badge" [ngClass]="badgeStatutCommande(c.statut)">{{ libelleStatutCommande(c.statut) }}</span>
              </div>
              <div class="cmd-item__parties">
                <span class="cmd-item__person">
                  <i class="fal fa-user-alt"></i> {{ c.expediteur?.nom ?? c.expediteurNom ?? '?' }}
                </span>
                <i class="fal fa-long-arrow-right cmd-item__arrow"></i>
                <span class="cmd-item__person">
                  <i class="fal fa-user-alt"></i> {{ c.destinataire?.nom ?? c.destinataireNom ?? '?' }}
                </span>
              </div>
              <div class="cmd-item__meta">
                <span class="cmd-item__meta-chip" *ngIf="c.trajetZoneDepartNom">
                  <i class="fal fa-map-marker-alt"></i>
                  {{ c.trajetZoneDepartNom }}
                  <i class="fal fa-arrow-right" style="font-size:9px"></i>
                  {{ c.trajetZoneDestinationNom ?? '—' }}
                </span>
                <span class="cmd-item__meta-chip cmd-item__meta-chip--articles" *ngIf="c.articles?.length">
                  <i class="fal fa-box"></i>
                  {{ c.articles.length }} article{{ c.articles.length > 1 ? 's' : '' }}
                </span>
                <span class="cmd-item__meta-chip cmd-item__meta-chip--montant" *ngIf="c.montantTotal">
                  <i class="fal fa-tag"></i>
                  {{ c.montantTotal | number:'1.0-0' }} FCFA
                </span>
                <span class="cmd-item__meta-chip cmd-item__meta-chip--date" *ngIf="c.dateCreation">
                  <i class="fal fa-calendar-alt"></i>
                  {{ c.dateCreation | date:'dd/MM/yy' }}
                </span>
              </div>
            </div>
          </label>
        </div>

        <!-- Résultats de la recherche globale (commandes hors liste éligible) -->
        <ng-container *ngIf="!chargementCommandes && !rechercheEnCours && commandesRechercheesUniques.length > 0">
          <div class="search-results-header">
            <i class="fal fa-search"></i>
            Résultats pour « {{ rechercheCommande }} » — hors critères d'éligibilité
          </div>
          <div class="commandes-liste commandes-liste--recherche">
            <label class="cmd-item cmd-item--recherche"
                   *ngFor="let c of commandesRechercheesUniques"
                   [class.cmd-item--selected]="commandesSelectionnees.has(c.id)">
              <div class="cmd-item__checkbox">
                <input type="checkbox"
                       [checked]="commandesSelectionnees.has(c.id)"
                       (change)="toggleCommande(c.id)" />
                <div class="cmd-item__check-visual">
                  <i class="fal fa-check" *ngIf="commandesSelectionnees.has(c.id)"></i>
                </div>
              </div>
              <div class="cmd-item__body">
                <div class="cmd-item__top">
                  <strong class="cmd-item__ref-num">{{ c.numeroCommande ?? c.numeroSuivi ?? '#' + c.id }}</strong>
                  <span class="cmd-item__statut-badge" [ngClass]="badgeStatutCommande(c.statut)">{{ libelleStatutCommande(c.statut) }}</span>
                </div>
                <div class="cmd-item__parties">
                  <span class="cmd-item__person">
                    <i class="fal fa-user-alt"></i> {{ c.expediteur?.nom ?? c.expediteurNom ?? '?' }}
                  </span>
                  <i class="fal fa-long-arrow-right cmd-item__arrow"></i>
                  <span class="cmd-item__person">
                    <i class="fal fa-user-alt"></i> {{ c.destinataire?.nom ?? c.destinataireNom ?? '?' }}
                  </span>
                </div>
                <div class="cmd-item__meta">
                  <span class="cmd-item__meta-chip" *ngIf="c.trajetZoneDepartNom">
                    <i class="fal fa-map-marker-alt"></i>
                    {{ c.trajetZoneDepartNom }}
                    <i class="fal fa-arrow-right" style="font-size:9px"></i>
                    {{ c.trajetZoneDestinationNom ?? '—' }}
                  </span>
                  <span class="cmd-item__meta-chip cmd-item__meta-chip--articles" *ngIf="c.articles?.length">
                    <i class="fal fa-box"></i> {{ c.articles.length }} article{{ c.articles.length > 1 ? 's' : '' }}
                  </span>
                  <span class="cmd-item__meta-chip cmd-item__meta-chip--montant" *ngIf="c.montantTotal">
                    <i class="fal fa-tag"></i> {{ c.montantTotal | number:'1.0-0' }} FCFA
                  </span>
                  <span class="cmd-item__meta-chip cmd-item__meta-chip--date" *ngIf="c.dateCreation">
                    <i class="fal fa-calendar-alt"></i> {{ c.dateCreation | date:'dd/MM/yy' }}
                  </span>
                </div>
              </div>
            </label>
          </div>
        </ng-container>

      </div>

      <div class="modal-footer">
        <button class="btn-modal-cancel" (click)="retourEtape1()" [disabled]="creationEnCours">
          <i class="fal fa-arrow-left"></i> Retour
        </button>
        <button class="btn-modal-primary" (click)="soumettreCreation()" [disabled]="creationEnCours">
          <ng-container *ngIf="!creationEnCours">
            <i class="fal fa-check"></i>
            Créer le manifeste
            <span class="btn-badge" *ngIf="commandesSelectionnees.size > 0">{{ commandesSelectionnees.size }}</span>
          </ng-container>
          <ng-container *ngIf="creationEnCours">
            <div class="spinner spinner--xs spinner--white"></div>
            Création en cours…
          </ng-container>
        </button>
      </div>

    </ng-container>

  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<!-- MODAL DÉTAIL COMPLET D'UN MANIFESTE                                        -->
<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="afficherDetailCommandes" (click)="fermerDetailCommandes()">
  <div class="dtl-modal" (click)="$event.stopPropagation()">

    <!-- ── En-tête gradient ── -->
    <div class="dtl-header">
      <div class="dtl-header__left">
        <div class="dtl-header__icon">
          <i class="fal fa-file-alt"></i>
        </div>
        <div>
          <h3 class="dtl-header__title">Détail du manifeste</h3>
          <p class="dtl-header__ref">{{ manifesteSelectionne?.numeroReference ?? 'Manifeste #' + manifesteSelectionne?.id }}</p>
        </div>
      </div>
      <button class="dtl-close" (click)="fermerDetailCommandes()">
        <i class="fal fa-times"></i>
      </button>
    </div>

    <!-- ── Bandeau trajet redesigné ── -->
    <div class="dtl-trajet" *ngIf="manifesteSelectionne">
      <div class="dtl-trajet__station dtl-trajet__station--depart">
        <div class="dtl-trajet__pin dtl-trajet__pin--depart">
          <i class="fal fa-map-marker-alt"></i>
        </div>
        <span class="dtl-trajet__label">DÉPART</span>
        <span class="dtl-trajet__city">{{ manifesteSelectionne.zoneDepartNom ?? '—' }}</span>
      </div>
      <div class="dtl-trajet__track">
        <div class="dtl-trajet__line"></div>
        <div class="dtl-trajet__truck">
          <i class="fal fa-truck"></i>
        </div>
        <div class="dtl-trajet__line"></div>
      </div>
      <div class="dtl-trajet__station dtl-trajet__station--arrivee">
        <div class="dtl-trajet__pin dtl-trajet__pin--arrivee">
          <i class="fal fa-map-marker-alt"></i>
        </div>
        <span class="dtl-trajet__label">ARRIVÉE</span>
        <span class="dtl-trajet__city">{{ manifesteSelectionne.zoneArriveeNom ?? '—' }}</span>
      </div>
    </div>

    <div class="dtl-body" *ngIf="manifesteSelectionne">

      <!-- ── KPI cards ── -->
      <div class="dtl-kpis">
        <div class="dtl-kpi">
          <div class="dtl-kpi__icon dtl-kpi__icon--indigo"><i class="fal fa-hashtag"></i></div>
          <div class="dtl-kpi__content">
            <span class="dtl-kpi__label">Référence</span>
            <span class="dtl-kpi__val">{{ manifesteSelectionne.numeroReference ?? '—' }}</span>
          </div>
        </div>
        <div class="dtl-kpi">
          <div class="dtl-kpi__icon dtl-kpi__icon--amber"><i class="fal fa-tag"></i></div>
          <div class="dtl-kpi__content">
            <span class="dtl-kpi__label">Statut</span>
            <span class="statut-badge dtl-kpi__badge" [ngClass]="badgeStatut(statutManifeste(manifesteSelectionne))">
              {{ libelleStatut(statutManifeste(manifesteSelectionne)) }}
            </span>
          </div>
        </div>
        <div class="dtl-kpi">
          <div class="dtl-kpi__icon dtl-kpi__icon--blue"><i class="fal fa-paper-plane"></i></div>
          <div class="dtl-kpi__content">
            <span class="dtl-kpi__label">Expédition</span>
            <span class="dtl-kpi__val">{{ (manifesteSelectionne.dateExpedition | date:'dd/MM/yyyy') ?? '—' }}</span>
            <span class="dtl-kpi__sub" *ngIf="manifesteSelectionne.dateExpedition">{{ manifesteSelectionne.dateExpedition | date:'HH:mm' }}</span>
          </div>
        </div>
        <div class="dtl-kpi">
          <div class="dtl-kpi__icon dtl-kpi__icon--green"><i class="fal fa-flag-checkered"></i></div>
          <div class="dtl-kpi__content">
            <span class="dtl-kpi__label">Arrivée</span>
            <span class="dtl-kpi__val">{{ manifesteSelectionne.dateArrivee ? (manifesteSelectionne.dateArrivee | date:'dd/MM/yyyy') : '—' }}</span>
            <span class="dtl-kpi__sub" *ngIf="manifesteSelectionne.dateArrivee">{{ manifesteSelectionne.dateArrivee | date:'HH:mm' }}</span>
          </div>
        </div>
      </div>

      <!-- ── Infos complémentaires ── -->
      <div class="dtl-meta-row"
           *ngIf="manifesteSelectionne.chauffeur || manifesteSelectionne.immatriculationVehicule || manifesteSelectionne.poidsTotal || manifesteSelectionne.nombreTotalColis != null">
        <span class="dtl-meta-chip" *ngIf="manifesteSelectionne.chauffeur">
          <i class="fal fa-user-tie"></i>
          {{ manifesteSelectionne.chauffeur.prenom }} {{ manifesteSelectionne.chauffeur.nom }}
        </span>
        <span class="dtl-meta-chip" *ngIf="manifesteSelectionne.immatriculationVehicule">
          <i class="fal fa-truck"></i> {{ manifesteSelectionne.immatriculationVehicule }}
        </span>
        <span class="dtl-meta-chip" *ngIf="manifesteSelectionne.poidsTotal">
          <i class="fal fa-weight"></i> {{ manifesteSelectionne.poidsTotal }} kg
        </span>
        <span class="dtl-meta-chip dtl-meta-chip--teal" *ngIf="manifesteSelectionne.nombreTotalColis != null">
          <i class="fal fa-boxes"></i> {{ manifesteSelectionne.nombreTotalColis }} colis
        </span>
      </div>

      <!-- Contenu / Observations -->
      <div class="dtl-obs" *ngIf="manifesteSelectionne.descriptionContenu || manifesteSelectionne.observations">
        <div class="dtl-obs__item" *ngIf="manifesteSelectionne.descriptionContenu">
          <span class="dtl-obs__label"><i class="fal fa-list-alt"></i> Contenu</span>
          <span class="dtl-obs__text">{{ manifesteSelectionne.descriptionContenu }}</span>
        </div>
        <div class="dtl-obs__item dtl-obs__item--warn" *ngIf="manifesteSelectionne.observations">
          <span class="dtl-obs__label"><i class="fal fa-sticky-note"></i> Observations</span>
          <span class="dtl-obs__text">{{ manifesteSelectionne.observations }}</span>
        </div>
      </div>

      <!-- ── Actions statut ── -->
      <div class="dtl-actions-section"
           *ngIf="['EN_PREPARATION','CHARGE','EXPEDIE','EN_TRANSIT'].includes(statutManifeste(manifesteSelectionne))">
        <div class="dtl-section-title"><i class="fal fa-exchange-alt"></i> Actions</div>
        <div class="dtl-actions-row">
          <button class="dtl-action-btn dtl-action-btn--teal"
                  *ngIf="statutManifeste(manifesteSelectionne) === 'EN_PREPARATION'"
                  (click)="changerStatut(manifesteSelectionne, 'CHARGE'); fermerDetailCommandes()">
            <div class="dtl-action-btn__icon"><i class="fal fa-truck-loading"></i></div>
            <div class="dtl-action-btn__text">
              <strong>Marquer comme chargé</strong>
              <span>Colis chargés sur le véhicule</span>
            </div>
            <i class="fal fa-chevron-right dtl-action-btn__arrow"></i>
          </button>
          <button class="dtl-action-btn dtl-action-btn--blue"
                  *ngIf="statutManifeste(manifesteSelectionne) === 'CHARGE'"
                  (click)="changerStatut(manifesteSelectionne, 'EXPEDIE'); fermerDetailCommandes()">
            <div class="dtl-action-btn__icon"><i class="fal fa-paper-plane"></i></div>
            <div class="dtl-action-btn__text">
              <strong>Marquer comme expédié</strong>
              <span>Départ en direction de la destination</span>
            </div>
            <i class="fal fa-chevron-right dtl-action-btn__arrow"></i>
          </button>
          <button class="dtl-action-btn dtl-action-btn--orange"
                  *ngIf="statutManifeste(manifesteSelectionne) === 'EXPEDIE'"
                  (click)="changerStatut(manifesteSelectionne, 'EN_TRANSIT'); fermerDetailCommandes()">
            <div class="dtl-action-btn__icon"><i class="fal fa-route"></i></div>
            <div class="dtl-action-btn__text">
              <strong>Marquer en transit</strong>
              <span>En cours d'acheminement</span>
            </div>
            <i class="fal fa-chevron-right dtl-action-btn__arrow"></i>
          </button>
          <button class="dtl-action-btn dtl-action-btn--green"
                  *ngIf="['EN_TRANSIT','EXPEDIE'].includes(statutManifeste(manifesteSelectionne))"
                  (click)="changerStatut(manifesteSelectionne, 'RECEPTIONNE'); fermerDetailCommandes()">
            <div class="dtl-action-btn__icon"><i class="fal fa-check-double"></i></div>
            <div class="dtl-action-btn__text">
              <strong>Confirmer la réception</strong>
              <span>Marchandises réceptionnées à destination</span>
            </div>
            <i class="fal fa-chevron-right dtl-action-btn__arrow"></i>
          </button>
        </div>
      </div>

      <!-- ── Commandes associées ── -->
      <div class="dtl-section">
        <div class="dtl-section-header">
          <div class="dtl-section-title"><i class="fal fa-boxes"></i> Commandes associées</div>
          <span class="dtl-section-badge" *ngIf="!chargementDetail">{{ commandesManifeste.length }}</span>
        </div>

        <div class="etat-inline" *ngIf="chargementDetail">
          <div class="spinner spinner--sm"></div>
          <span>Chargement des commandes…</span>
        </div>

        <div class="dtl-empty" *ngIf="!chargementDetail && commandesManifeste.length === 0">
          <div class="dtl-empty__icon"><i class="fal fa-inbox"></i></div>
          <p class="dtl-empty__title">Aucune commande associée</p>
          <p class="dtl-empty__sub">Ce manifeste ne contient pas encore de commandes.</p>
        </div>

        <table class="data-table data-table--sm" *ngIf="!chargementDetail && commandesManifeste.length > 0">
          <thead>
            <tr>
              <th>Référence</th>
              <th>Expéditeur → Destinataire</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of commandesManifeste">
              <td>
                <strong class="ref-link" (click)="voirDetailCommande(c.id)">{{ c.numeroCommande ?? c.numeroSuivi ?? '#' + c.id }}</strong>
              </td>
              <td>
                <span class="dtl-parties">
                  <span>{{ c.expediteur?.nom ?? c.expediteurNom ?? '—' }}</span>
                  <i class="fal fa-arrow-right dtl-parties__arrow"></i>
                  <span>{{ c.destinataire?.nom ?? c.destinataireNom ?? '—' }}</span>
                </span>
              </td>
              <td>
                <span class="statut-badge" [ngClass]="badgeStatutCommande(c.statut ?? c.status)">
                  {{ libelleStatutCommande(c.statut ?? c.status) }}
                </span>
              </td>
              <td>
                <div class="actions-cell">
                  <button class="btn-action btn-action--blue" title="Voir" (click)="voirDetailCommande(c.id)"><i class="fal fa-eye"></i></button>
                  <button class="btn-action btn-action--danger" title="Retirer du manifeste"
                          *ngIf="(manifesteSelectionne?.statut ?? manifesteSelectionne?.status) === 'EN_PREPARATION'"
                          (click)="retirerCommandeManifeste(c.id)">
                    <i class="fal fa-unlink"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ── Historique timeline ── -->
      <div class="dtl-section" *ngIf="manifesteSelectionne.historique?.length">
        <div class="dtl-section-header">
          <div class="dtl-section-title"><i class="fal fa-history"></i> Historique</div>
          <span class="dtl-section-badge">{{ manifesteSelectionne.historique.length }}</span>
        </div>
        <ul class="dtl-timeline">
          <li *ngFor="let h of manifesteSelectionne.historique; let last = last"
              class="dtl-timeline__item"
              [class.dtl-timeline__item--creation]="h.includes('créé')"
              [class.dtl-timeline__item--statut]="h.includes('Statut changé')"
              [class.dtl-timeline__item--modif]="h.includes('modifié')">
            <div class="dtl-timeline__dot">
              <i class="fal fa-plus"          *ngIf="h.includes('créé')"></i>
              <i class="fal fa-exchange-alt"  *ngIf="h.includes('Statut changé')"></i>
              <i class="fal fa-edit"          *ngIf="h.includes('modifié') && !h.includes('créé')"></i>
              <i class="fal fa-info"          *ngIf="!h.includes('créé') && !h.includes('Statut changé') && !h.includes('modifié')"></i>
            </div>
            <div class="dtl-timeline__connector" *ngIf="!last"></div>
            <div class="dtl-timeline__content">
              <span class="dtl-timeline__text">{{ formaterHistorique(h) }}</span>
              <span class="dtl-timeline__date" *ngIf="extraireDate(h)">{{ extraireDate(h) }}</span>
            </div>
          </li>
        </ul>
      </div>

    </div>

    <div class="dtl-footer">
      <span class="dtl-footer__info" *ngIf="!chargementDetail && commandesManifeste.length > 0">
        <i class="fal fa-boxes"></i> <strong>{{ commandesManifeste.length }}</strong> commande(s)
      </span>
      <button class="btn-modal-cancel" (click)="fermerDetailCommandes()">
        <i class="fal fa-times"></i> Fermer
      </button>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<!-- DIALOG RÉCONCILIATION                                                       -->
<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="afficherDialogReconciliation" (click)="fermerReconciliation()">
  <div class="rec-modal" [class.rec-modal--split]="commandeEnDetail || chargementDetailSheet"
       (click)="$event.stopPropagation()">

    <!-- ════════════ PANNEAU GAUCHE (liste réconciliation) ════════════ -->
    <div class="rec-panel-main">

      <!-- ── Bannière header ────────────────────────────────────────── -->
      <div class="rec-header">
        <div class="rec-header__bg"></div>
        <div class="rec-header__content">
          <div class="rec-header__icon"><i class="fal fa-clipboard-check"></i></div>
          <div class="rec-header__text">
            <h3>Réconciliation des colis</h3>
            <div class="rec-header__meta">
              <span class="rec-header__tag"><i class="fal fa-hashtag"></i>
                {{ manifesteSelectionne?.numeroReference ?? 'Manifeste #' + manifesteSelectionne?.id }}
              </span>
              <span class="rec-header__sep">·</span>
              <span class="rec-header__tag"><i class="fal fa-map-marker-alt"></i>
                Arrivée à {{ manifesteSelectionne?.zoneArriveeNom ?? '?' }}
              </span>
            </div>
          </div>
        </div>
        <button class="rec-header__close" (click)="fermerReconciliation()" [disabled]="reconciliationEnCours">
          <i class="fal fa-times"></i>
        </button>
      </div>

      <!-- ── KPI counters ───────────────────────────────────────────── -->
      <div class="rec-kpis" *ngIf="lignesReconciliation.length > 0">
        <div class="rec-kpi rec-kpi--total">
          <div class="rec-kpi__icon"><i class="fal fa-boxes"></i></div>
          <div class="rec-kpi__body">
            <span class="rec-kpi__num">{{ lignesReconciliation.length }}</span>
            <span class="rec-kpi__lbl">Total</span>
          </div>
        </div>
        <div class="rec-kpi rec-kpi--ok">
          <div class="rec-kpi__icon"><i class="fal fa-check-circle"></i></div>
          <div class="rec-kpi__body">
            <span class="rec-kpi__num">{{ nbRecuOk() }}</span>
            <span class="rec-kpi__lbl">Reçus OK</span>
          </div>
        </div>
        <div class="rec-kpi rec-kpi--manquant">
          <div class="rec-kpi__icon"><i class="fal fa-question-circle"></i></div>
          <div class="rec-kpi__body">
            <span class="rec-kpi__num">{{ nbManquant() }}</span>
            <span class="rec-kpi__lbl">Manquants</span>
          </div>
        </div>
        <div class="rec-kpi rec-kpi--endommage">
          <div class="rec-kpi__icon"><i class="fal fa-exclamation-triangle"></i></div>
          <div class="rec-kpi__body">
            <span class="rec-kpi__num">{{ nbEndommage() }}</span>
            <span class="rec-kpi__lbl">Endommagés</span>
          </div>
        </div>
      </div>

      <!-- ── Barre de progression ───────────────────────────────────── -->
      <div class="rec-progress" *ngIf="lignesReconciliation.length > 0">
        <div class="rec-progress__track">
          <div class="rec-progress__fill rec-progress__fill--ok"
               [style.width.%]="lignesReconciliation.length ? (nbRecuOk() / lignesReconciliation.length) * 100 : 0"></div>
          <div class="rec-progress__fill rec-progress__fill--manquant"
               [style.width.%]="lignesReconciliation.length ? (nbManquant() / lignesReconciliation.length) * 100 : 0"></div>
          <div class="rec-progress__fill rec-progress__fill--endommage"
               [style.width.%]="lignesReconciliation.length ? (nbEndommage() / lignesReconciliation.length) * 100 : 0"></div>
        </div>
        <span class="rec-progress__pct">
          {{ lignesReconciliation.length ? ((nbRecuOk() / lignesReconciliation.length) * 100 | number:'1.0-0') : 0 }}%
        </span>
      </div>

      <!-- ── Corps scrollable ──────────────────────────────────────── -->
      <div class="rec-body">

        <div class="rec-loading" *ngIf="chargementDetail">
          <div class="spinner"></div><span>Chargement des commandes…</span>
        </div>

        <div class="rec-empty" *ngIf="!chargementDetail && lignesReconciliation.length === 0">
          <div class="rec-empty__icon"><i class="fal fa-box-open"></i></div>
          <p>Aucune commande associée à ce manifeste.</p>
        </div>

        <div class="rec-cards" *ngIf="!chargementDetail && lignesReconciliation.length > 0">
          <div class="rec-card"
               *ngFor="let ligne of lignesReconciliation; let i = index"
               [class.rec-card--ok]="ligne.etat === 'RECU_OK'"
               [class.rec-card--manquant]="ligne.etat === 'MANQUANT'"
               [class.rec-card--endommage]="ligne.etat === 'ENDOMMAGE'"
               [class.rec-card--active]="commandeEnDetail?.id === ligne.commandeId">

            <!-- Accent latéral -->
            <div class="rec-card__accent"></div>

            <!-- Corps de la carte (2 lignes) -->
            <div class="rec-card__body">

              <!-- Ligne 1 : référence + bouton œil -->
              <div class="rec-card__row1">
                <span class="rec-card__idx">{{ i + 1 }}</span>
                <span class="rec-card__num">{{ ligne.numeroCommande }}</span>
                <button class="rec-card__eye"
                        [class.rec-card__eye--active]="commandeEnDetail?.id === ligne.commandeId"
                        (click)="ouvrirSheetCommande(ligne.commandeId)"
                        title="Voir le détail de cette commande">
                  <i class="fal fa-eye" *ngIf="commandeEnDetail?.id !== ligne.commandeId"></i>
                  <i class="fal fa-eye-slash" *ngIf="commandeEnDetail?.id === ligne.commandeId"></i>
                </button>
              </div>

              <!-- Ligne 2 : pills état + champ note -->
              <div class="rec-card__row2">
                <div class="rec-card__btns">
                  <button class="rec-pill rec-pill--ok" [class.rec-pill--active]="ligne.etat === 'RECU_OK'"
                          (click)="ligne.etat = 'RECU_OK'">
                    <i class="fal fa-check"></i> OK
                  </button>
                  <button class="rec-pill rec-pill--manquant" [class.rec-pill--active]="ligne.etat === 'MANQUANT'"
                          (click)="ligne.etat = 'MANQUANT'">
                    <i class="fal fa-question"></i> Manquant
                  </button>
                  <button class="rec-pill rec-pill--endommage" [class.rec-pill--active]="ligne.etat === 'ENDOMMAGE'"
                          (click)="ligne.etat = 'ENDOMMAGE'">
                    <i class="fal fa-exclamation-triangle"></i> Endommagé
                  </button>
                </div>
                <input type="text" [(ngModel)]="ligne.observations"
                       placeholder="Note…" class="rec-card__obs-input" />
              </div>

            </div>
          </div>
        </div>

        <div class="rec-obs-global" *ngIf="!chargementDetail && lignesReconciliation.length > 0">
          <label class="rec-obs-global__label">
            <i class="fal fa-sticky-note"></i> Observations générales
          </label>
          <textarea class="rec-obs-global__input" [(ngModel)]="observationsReconciliation"
                    rows="2" placeholder="Notes globales sur la réception…"></textarea>
        </div>

      </div>

      <!-- ── Footer ────────────────────────────────────────────────── -->
      <div class="rec-footer">
        <div class="rec-footer__summary" *ngIf="lignesReconciliation.length > 0">
          <span class="rec-footer__chip rec-footer__chip--ok"><i class="fal fa-check"></i> {{ nbRecuOk() }}</span>
          <span class="rec-footer__chip rec-footer__chip--warn"><i class="fal fa-question"></i> {{ nbManquant() }}</span>
          <span class="rec-footer__chip rec-footer__chip--danger"><i class="fal fa-exclamation"></i> {{ nbEndommage() }}</span>
        </div>
        <button class="rec-footer__cancel" (click)="fermerReconciliation()" [disabled]="reconciliationEnCours">
          Annuler
        </button>
        <button class="rec-footer__submit" (click)="soumettreReconciliation()"
                [disabled]="reconciliationEnCours || lignesReconciliation.length === 0">
          <i class="fal fa-spinner fa-spin" *ngIf="reconciliationEnCours"></i>
          <i class="fal fa-check-double" *ngIf="!reconciliationEnCours"></i>
          Valider
        </button>
      </div>

    </div><!-- /rec-panel-main -->

    <!-- ════════════ PANNEAU DROIT (sheet détail commande) ════════════ -->
    <div class="rec-sheet" *ngIf="commandeEnDetail || chargementDetailSheet">

      <!-- Header sheet -->
      <div class="rec-sheet__header">
        <div class="rec-sheet__header-left">
          <div class="rec-sheet__icon"><i class="fal fa-box"></i></div>
          <div>
            <div class="rec-sheet__title">Détail commande</div>
            <div class="rec-sheet__ref" *ngIf="commandeEnDetail">
              {{ commandeEnDetail.numeroCommande }}
            </div>
          </div>
        </div>
        <button class="rec-sheet__close" (click)="fermerSheetCommande()">
          <i class="fal fa-times"></i>
        </button>
      </div>

      <!-- Chargement -->
      <div class="rec-sheet__loading" *ngIf="chargementDetailSheet">
        <div class="spinner"></div>
        <span>Chargement…</span>
      </div>

      <!-- Contenu scrollable -->
      <div class="rec-sheet__body" *ngIf="commandeEnDetail && !chargementDetailSheet">

        <!-- ── Statut + meta ─────────────────────────────────────── -->
        <div class="sh-status-bar">
          <span class="statut-badge" [ngClass]="badgeStatutCommande(commandeEnDetail.statut ?? commandeEnDetail.status ?? '')">
            {{ libelleStatutCommande(commandeEnDetail.statut ?? commandeEnDetail.status ?? '') }}
          </span>
          <div class="sh-status-bar__meta">
            <span *ngIf="commandeEnDetail.dateCreation">
              <i class="fal fa-calendar-alt"></i>{{ commandeEnDetail.dateCreation | date:'dd/MM/yy' }}
            </span>
            <span *ngIf="commandeEnDetail.typeEnvoi ?? commandeEnDetail.type">
              <i class="fal fa-tag"></i>{{ commandeEnDetail.typeEnvoi ?? commandeEnDetail.type }}
            </span>
          </div>
        </div>

        <!-- ── Numéro de suivi ───────────────────────────────────── -->
        <div class="sh-suivi" *ngIf="commandeEnDetail.numeroSuivi">
          <i class="fal fa-barcode"></i>
          <span class="sh-suivi__label">Suivi</span>
          <span class="sh-suivi__val">{{ commandeEnDetail.numeroSuivi }}</span>
        </div>

        <!-- ── Trajet ────────────────────────────────────────────── -->
        <div class="sh-trajet">
          <div class="sh-trajet__label"><i class="fal fa-route"></i> Trajet</div>

          <div class="sh-party sh-party--exp">
            <div class="sh-party__dot sh-party__dot--exp"><i class="fal fa-circle"></i></div>
            <div class="sh-party__info">
              <span class="sh-party__role">Expéditeur</span>
              <span class="sh-party__name">
                {{ (commandeEnDetail.expediteur?.prenom ?? '') + ' ' + (commandeEnDetail.expediteur?.nom ?? commandeEnDetail.expediteurNom ?? '—') }}
              </span>
              <span class="sh-party__contact" *ngIf="commandeEnDetail.expediteur?.telephone">
                <i class="fal fa-phone-alt"></i>{{ commandeEnDetail.expediteur.telephone }}
              </span>
              <span class="sh-party__contact" *ngIf="commandeEnDetail.expediteur?.email">
                <i class="fal fa-envelope"></i>{{ commandeEnDetail.expediteur.email }}
              </span>
            </div>
          </div>

          <div class="sh-trajet__connector">
            <div class="sh-trajet__line"></div>
            <div class="sh-trajet__zone"
                 *ngIf="commandeEnDetail.zoneDepartNom ?? commandeEnDetail.zoneDepart?.nom">
              <i class="fal fa-map-marker-alt"></i>
              {{ commandeEnDetail.zoneDepartNom ?? commandeEnDetail.zoneDepart?.nom }}
              <i class="fal fa-long-arrow-right"></i>
              {{ commandeEnDetail.zoneArriveeNom ?? commandeEnDetail.zoneArrivee?.nom ?? '?' }}
            </div>
          </div>

          <div class="sh-party sh-party--dest">
            <div class="sh-party__dot sh-party__dot--dest"><i class="fal fa-map-marker-alt"></i></div>
            <div class="sh-party__info">
              <span class="sh-party__role">Destinataire</span>
              <span class="sh-party__name">
                {{ (commandeEnDetail.destinataire?.prenom ?? '') + ' ' + (commandeEnDetail.destinataire?.nom ?? commandeEnDetail.destinataireNom ?? '—') }}
              </span>
              <span class="sh-party__contact" *ngIf="commandeEnDetail.destinataire?.telephone">
                <i class="fal fa-phone-alt"></i>{{ commandeEnDetail.destinataire.telephone }}
              </span>
              <span class="sh-party__addr" *ngIf="commandeEnDetail.destinataire?.adresse ?? commandeEnDetail.adresseLivraison">
                <i class="fal fa-home"></i>
                {{ commandeEnDetail.destinataire?.adresse ?? commandeEnDetail.adresseLivraison }}
              </span>
            </div>
          </div>
        </div>

        <!-- ── Résumé financier ──────────────────────────────────── -->
        <div class="sh-finance">
          <div class="sh-finance__card sh-finance__card--primary">
            <span class="sh-finance__lbl"><i class="fal fa-coins"></i> Montant total</span>
            <span class="sh-finance__val">
              {{ (commandeEnDetail.montantTotal ?? commandeEnDetail.montant ?? 0) | number:'1.0-0' }}
              <small>FCFA</small>
            </span>
          </div>
          <div class="sh-finance__row">
            <div class="sh-finance__item" *ngIf="commandeEnDetail.poids ?? commandeEnDetail.poidsTotal">
              <span class="sh-finance__lbl"><i class="fal fa-weight"></i> Poids</span>
              <span class="sh-finance__val--sm">{{ commandeEnDetail.poids ?? commandeEnDetail.poidsTotal }} kg</span>
            </div>
            <div class="sh-finance__item" *ngIf="commandeEnDetail.articles?.length">
              <span class="sh-finance__lbl"><i class="fal fa-boxes"></i> Colis</span>
              <span class="sh-finance__val--sm">{{ commandeEnDetail.articles.length }}</span>
            </div>
            <div class="sh-finance__item" *ngIf="commandeEnDetail.quantiteTotale">
              <span class="sh-finance__lbl"><i class="fal fa-layer-group"></i> Qté totale</span>
              <span class="sh-finance__val--sm">{{ commandeEnDetail.quantiteTotale }}</span>
            </div>
          </div>
        </div>

        <!-- ── Articles / Colis ──────────────────────────────────── -->
        <div class="sh-articles" *ngIf="commandeEnDetail.articles?.length > 0">
          <div class="sh-articles__header">
            <i class="fal fa-layer-group"></i> Articles / Colis
            <span class="sh-articles__count">{{ commandeEnDetail.articles.length }}</span>
          </div>
          <div class="sh-article" *ngFor="let art of commandeEnDetail.articles; let i = index">
            <div class="sh-article__num">{{ i + 1 }}</div>
            <div class="sh-article__body">
              <div class="sh-article__top">
                <span class="sh-article__nom">{{ art.nom ?? ('Colis ' + (i + 1)) }}</span>
                <span class="sh-article__prix" *ngIf="art.montant">{{ art.montant | number:'1.0-0' }} F</span>
              </div>
              <p class="sh-article__desc" *ngIf="art.description">{{ art.description }}</p>
              <div class="sh-article__chips">
                <span class="sh-chip" *ngIf="art.quantite"><i class="fal fa-hashtag"></i> {{ art.quantite }}</span>
                <span class="sh-chip" *ngIf="art.poids ?? art.poidsReel"><i class="fal fa-weight"></i> {{ art.poids ?? art.poidsReel }} kg</span>
                <span class="sh-chip" *ngIf="art.volume"><i class="fal fa-cube"></i> {{ art.volume }} m³</span>
                <span class="sh-chip" *ngIf="art.typeArticle"><i class="fal fa-tag"></i> {{ art.typeArticle }}</span>
                <span class="sh-chip" *ngIf="art.typeConditionnement"><i class="fal fa-box"></i> {{ art.typeConditionnement }}</span>
                <span class="sh-chip" *ngIf="art.valeurDeclaree"><i class="fal fa-shield-alt"></i> {{ art.valeurDeclaree | number:'1.0-0' }} F</span>
                <span class="sh-chip sh-chip--success" *ngIf="art.flgEmballageDematral"><i class="fal fa-check-circle"></i> Emballé</span>
                <span class="sh-chip sh-chip--danger" *ngIf="art.endommage"><i class="fal fa-exclamation-triangle"></i> Endommagé</span>
              </div>
              <p class="sh-article__obs" *ngIf="art.observations">
                <i class="fal fa-sticky-note"></i> {{ art.observations }}
              </p>
            </div>
          </div>
        </div>

        <!-- ── Observations commande ─────────────────────────────── -->
        <div class="sh-obs" *ngIf="commandeEnDetail.observations">
          <div class="sh-obs__label"><i class="fal fa-comment-alt-lines"></i> Observations</div>
          <div class="sh-obs__text">{{ commandeEnDetail.observations }}</div>
        </div>

        <!-- ── Spacer pour éviter que le dernier élément colle au bas ─ -->
        <div style="flex: 1; min-height: 8px;"></div>

      </div>
    </div><!-- /rec-sheet -->

  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<!-- DIALOG AFFECTATION LIVREURS (LAST-MILE)                                    -->
<!-- ═══════════════════════════════════════════════════════════════════════════ -->
<div class="modal-backdrop" *ngIf="afficherDialogAffectation" (click)="fermerAffectation()">
  <div class="modal-card modal-card--large" (click)="$event.stopPropagation()">

    <div class="modal-header modal-header--affectation">
      <div class="modal-header__left">
        <div class="modal-header__icon"><i class="fal fa-user-hard-hat"></i></div>
        <div>
          <h3>Affectation livreurs — Last mile</h3>
          <p class="modal-header__sub">
            Manifeste {{ manifesteSelectionne?.numeroReference ?? '#' + manifesteSelectionne?.id }}
            — Zone {{ manifesteSelectionne?.zoneArriveeNom ?? '?' }}
          </p>
        </div>
      </div>
      <button class="modal-close" (click)="fermerAffectation()" [disabled]="affectationEnCours">
        <i class="fal fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="modal-loading" *ngIf="chargementDetail || chargementLivreurs">
        <div class="spinner"></div><span>Chargement…</span>
      </div>

      <div *ngIf="!chargementDetail && !chargementLivreurs">
        <div class="aff-info" *ngIf="lignesAffectation.length === 0">
          <i class="fal fa-info-circle"></i>
          Aucune commande réceptionnée à assigner dans ce manifeste.
        </div>

        <table class="rec-table" *ngIf="lignesAffectation.length > 0">
          <thead>
            <tr>
              <th>Commande</th>
              <th>Livreur assigné</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ligne of lignesAffectation"
                [class.aff-row--assigned]="ligne.livreurId != null">
              <td class="rec-cmd">
                <strong>{{ ligne.numeroCommande }}</strong>
              </td>
              <td>
                <select class="aff-select" [(ngModel)]="ligne.livreurId">
                  <option [ngValue]="null">— Choisir un livreur —</option>
                  <option *ngFor="let l of livreurs" [ngValue]="l.id">
                    {{ l.prenom }} {{ l.nom }}
                  </option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="aff-summary" *ngIf="lignesAffectation.length > 0">
          <i class="fal fa-info-circle"></i>
          {{ nbAffectationsAssignees }} / {{ lignesAffectation.length }} commandes assignées
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-modal-cancel" (click)="fermerAffectation()" [disabled]="affectationEnCours">
        Annuler
      </button>
      <button class="btn-modal-submit"
              (click)="soumettreAffectation()"
              [disabled]="affectationEnCours || lignesAffectation.length === 0">
        <i class="fal fa-paper-plane" *ngIf="!affectationEnCours"></i>
        <i class="fal fa-spinner fa-spin" *ngIf="affectationEnCours"></i>
        Affecter les livreurs
      </button>
    </div>
  </div>
</div>
